import {
    AccountI,
    AppointmentOrderI,
    BankAccountDTO,
    ConfirmWithdrawalDTO,
    DefaultMethodRequestDTO,
    FcAccountI,
    FrequencyRequest,
    ICreateEmptyOrder,
    ICreatedOrder,
    MessageDTO,
    OrderAppointmentRequestDTOI,
    OrderItemsI,
    SubscriptionTypeI,
    UserBilling,
    orderDTO,
} from '@interfaces/finance/general';
import fcFinancialServiceApiInstance from '@services/clients/fc-financial';
import axiosApiInstance from '@services/custom-axios-instance';
import { generateUrl } from "@services/generateUrl/generateUrl";

/**
 * @deprecated This flow is not longer supported
 */
export function createAccount(account: FcAccountI): Promise<string> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/fcfinancial/account/`,
            account
        )
        .then((response) => {
            return response.data as string;
        });
}

/**
 * @deprecated This flow is not longer supported
 */
export function getAccount(
    personId: string,
    organizationId: number
): Promise<AccountI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcfinancial/account/person/${personId}`,
            { params: { organizationId } }
        )
        .then((response) => {
            return response.data as AccountI[];
        });
}

/**
 * @deprecated This flow is not longer supported
 */
export function getPatientAccount(personId: string): Promise<AccountI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcfinancial/account/person/${personId}`
        )
        .then((response) => {
            return response.data as AccountI[];
        });
}

/**
 * @deprecated This flow is not longer supported
 */
export async function getAccountByCurrency(personId: string, organizationId: number, currencyCode: string, excludeRole?: string)
{
    const url = `${generateUrl()}/fcfinancial/account/person/${personId}/${currencyCode}`
    const response = await axiosApiInstance
        .get(url, { params: { organizationId, excludeRoleCode: excludeRole }});
    return response.data as AccountI[];
}

/**
 * @deprecated This flow is not longer supported
 */
export function getBilling(
    accountId: string | undefined,
    date: string | undefined,
    month: number | undefined,
    year: number | undefined
): Promise<UserBilling[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcfinancial/tax-billing/pending/${accountId}`,
            { params: { date, month, year } }
        )
        .then((response) => {
            return response.data as UserBilling[];
        });
}

export function getOrderIdToAppointment(
    orderId: number
): Promise<AppointmentOrderI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/emr/order/appointment/${orderId}`
        )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return undefined;
        });
}

export function setOrderIdToAppointment(data: OrderAppointmentRequestDTOI) {
    return axiosApiInstance
        .put(
            `${generateUrl()}/emr/order/appointment`,
            data
        )
        .then((response) => {
            return response.data;
        });
}

export function confirmWithdrawal(
    data: ConfirmWithdrawalDTO
): Promise<MessageDTO> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/fcfinancial/withdrawal/order`,
            data
        )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return undefined;
        });
}

export function setDefaultPayoutMethod(
    data: DefaultMethodRequestDTO
): Promise<MessageDTO> {
    return axiosApiInstance
        .put(
            `${generateUrl()}/fcfinancial/account/defaults/payout`,
            data
        )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return undefined;
        });
}

export function updateBillingFrequency(
    data: FrequencyRequest
): Promise<MessageDTO> {
    return axiosApiInstance
        .put(
            `${generateUrl()}/fcfinancial/account/frequency`,
            data
        )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return undefined;
        });
}

export function getFcTransactions(
    accountId: string | undefined,
    month: number | undefined,
    year: number | undefined
): Promise<OrderItemsI[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcfinancial/account-item/${accountId}`,
            { params: { month, year } }
        )
        .then((response) => {
            return response.data as OrderItemsI[];
        });
}

export function addBankAccount(data: BankAccountDTO): Promise<number> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/fcfinancial/bank-account/`,
            data
        )
        .then((response) => {
            return response.data as number;
        });
}

export function getBankAccountByAccount(
    accountId: string | undefined
): Promise<BankAccountDTO[]> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcfinancial/bank-account/account/${accountId}`
        )
        .then((response) => {
            return response.data as BankAccountDTO[];
        });
}

export function updateBankAccount(data: BankAccountDTO): Promise<MessageDTO> {
    return axiosApiInstance
        .put(
            `${generateUrl()}/fcfinancial/bank-account/`,
            data
        )
        .then((response) => {
            return response.data as MessageDTO;
        });
}

export function deleteBankAccount(bankAccountId: number): Promise<MessageDTO> {
    return axiosApiInstance
        .delete(
            `${generateUrl()}/fcfinancial/bank-account/${bankAccountId}`,
            undefined
        )
        .then((response) => {
            return response.data as MessageDTO;
        });
}

export function checkOrganizationSubscription(organizationId: number){
    return axiosApiInstance
        .get(
            `${generateUrl()}/fcfinancial/subscription/check/${organizationId}`
        )
        .then((response) => {
            const res = response
            return res.data as SubscriptionTypeI
        })
}

/**
 * @deprecated To delete after NOM024 deployment
 */
export function orderWithoutPayment(data: orderDTO): Promise<string>{
    return axiosApiInstance
        .post(
            `${generateUrl()}/fcfinancial/order/`,
            data
        )
        .then((response) => {
            return response.data as string;
        })
}

/**
 * Creates an empty order required for device interoperability
 * @param order Empty order to be created
 * @returns Return empty order params
 */
export async function createEmptyOrder(order: ICreateEmptyOrder)
{
    const endpoint = "/order/user/empty"
    const response = await fcFinancialServiceApiInstance.post<ICreatedOrder>(endpoint, order)
    return response.data
}
